import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <section className="pt-32 pb-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <h1 className="text-4xl sm:text-5xl font-black font-heading text-white mb-8">
            Privacy Policy
          </h1>
          
          <div className="glass-heavy rounded-2xl p-8 space-y-6 text-zinc-400">
            <div>
              <h2 className="text-2xl font-bold text-white mb-3">1. Information We Collect</h2>
              <p className="leading-relaxed">
                We collect personal information such as name, email address, and trading data to provide our services.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">2. How We Use Your Information</h2>
              <p className="leading-relaxed mb-3">
                Your information is used to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Provide and maintain our services</li>
                <li>Process transactions and payouts</li>
                <li>Send important notifications and updates</li>
                <li>Improve our platform and user experience</li>
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">3. Data Security</h2>
              <p className="leading-relaxed">
                We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, or destruction.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">4. Third-Party Services</h2>
              <p className="leading-relaxed">
                We may use third-party services for payment processing and analytics. These services have their own privacy policies.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">5. Your Rights</h2>
              <p className="leading-relaxed">
                You have the right to access, update, or delete your personal information. Contact us at support@ayronn.com for assistance.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-white mb-3">6. Contact Us</h2>
              <p className="leading-relaxed">
                If you have any questions about this Privacy Policy, please contact us at support@ayronn.com.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Privacy;